import $ from 'jquery';

const viewClasses = {
	list: 'product-wrapper--list product-new__wrapper--list',
	grid: 'product-wrapper--grid product-new__wrapper--grid'
};
const switcher = $(".product-wrapper__switch");
const cookie = getCookie('segment');


const documentLoaded = () => {

	if ( cookie === 'products' || !cookie || typeof cookie === "undefined" ) {
		switcher.addClass( 'products__flex' );
	}
}

documentLoaded();

$(".segment-trigger").on('click', hideSwitcher);

$('.product-wrapper__switch').each((i, element) => {
	const id = $(element).data('controls');
	const productWrapper = $(`#${id}`);

	let layout = getCookie('layout');
	if(layout)
	{
		toggleView(productWrapper, layout);
	}

	$(element).find('input[type=radio][name=product-view]').on('change', function (e) {
		toggleView(productWrapper, e.target.value);
		setCookie('layout', this.value, 1);
	});
});

function toggleView(productWrapper, value)
{
	productWrapper.removeClass([viewClasses['list'], viewClasses['grid']]);
	productWrapper.addClass(viewClasses[value]);
}

export function setCookie(name, value, lifetime_days) {
	let exp = new Date();
	exp.setDate(new Date().getDate() + lifetime_days);
	document.cookie = name + '=' + value + ';expires=' + exp.toUTCString() + ';path=/';
}

export function getCookie(name) {
	if(document.cookie) {
		let matches = document.cookie.match( '(^|;)\\s*' + name + '\\s*=\\s*([^;]+)' )?.pop() || ''

		if(matches) {
			return matches;
		}
	}
	return false;
}

function hideSwitcher(){
	if($(this).hasClass('products-trigger')){
		switcher.addClass('products__flex');
	} else if($(this).hasClass('onderdelen-trigger')){
		switcher.removeClass('products__flex');
	}
}